const faqItems = [
  {
    q: '今日大瓜是什么平台？',
    a: '今日大瓜是一个专注娱乐吃瓜资讯的聚合平台，每日为吃瓜爱好者提供最新、最全的娱乐大瓜内容。我们从全网筛选高质量吃瓜资讯，覆盖明星动态、影视综艺、行业八卦等多个维度，是吃瓜群众的一站式信息枢纽。',
  },
  {
    q: '吃瓜资讯多久更新一次？',
    a: '今日大瓜保持全天候滚动更新机制，编辑团队实时监测娱乐热点，确保每一条重磅大瓜都能在第一时间推送到你面前。平均每日更新 30-50 条精选吃瓜资讯，重大事件发生时更新频率会进一步提高。',
  },
  {
    q: '大瓜内容来源可靠吗？',
    a: '我们建立了严格的多源交叉核验机制，每一条吃瓜资讯均需经过至少两个独立信源验证后才会发布。同时标注信息来源和可信度等级，帮助你快速判断瓜的真假，告别吃假瓜的尴尬。',
  },
  {
    q: '如何第一时间收到最新吃瓜？',
    a: '你可以将今日大瓜加入浏览器收藏夹，或关注本站的热度榜单和最新快讯板块。我们正在开发移动端应用和消息推送功能，届时将支持更即时的吃瓜通知，敬请期待。',
  },
  {
    q: '可以投稿自己的吃瓜素材吗？',
    a: '当然可以！我们非常欢迎吃瓜爱好者投稿爆料。请通过本站「投稿爆料」板块提交你的吃瓜线索和素材，编辑团队会在 24 小时内审核，一经采用将注明投稿来源。',
  },
  {
    q: '吃瓜合集是如何分类整理的？',
    a: '吃瓜合集按照娱乐内容类型和话题热度进行分类，包括影视吃瓜、综艺吃瓜、明星动态、恋情曝光、争议事件等九大专题。每个专题都有独立索引页，方便你快速定位感兴趣的吃瓜内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            吃瓜常见问答
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">关于今日大瓜，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="text-base md:text-lg font-medium text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-xl mt-0.5 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}